const isInternetExplorer = () => {
  return window.navigator && window.navigator.msSaveOrOpenBlob
}

export default isInternetExplorer
